import { Box, Button, Dialog, IconButton, Typography, useTheme } from '@mui/material'
import React from 'react'

import { Icons } from '../../../utils/utilities'

const VideoPlayerCloseConfirmationDialog = ( { open, onClose, onTakeQuiz } ) => {

    const { border, layout } = useTheme()

    return (
        <Dialog open={open} maxWidth="xs" slotProps={{ paper: { sx: { maxWidth: "xs" } } }} >
            <Box display="flex" borderBottom={border[1]} padding="10px 20px" gap={layout.sectionsGap} justifyContent="space-between" alignItems="center" >
                <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px"  >Complete watching before leaving</Typography>
                <IconButton onClick={onClose}  >
                    {Icons.default.CloseIcon}
                </IconButton>
            </Box>
            <Box padding="20px">
                <Typography variant='body2'>
                    Complete watching the video and complete the quiz assigned before leaving.
                </Typography>
            </Box>
            <Box display="flex" gap="10px" alignItems="center" flexWrap="wrap" padding="20px" paddingTop="0" justifyContent="space-between">
                <Box display="flex" gap="10px" alignItems="center" flexWrap="wrap">
                    <Button size='small' disableElevation onClick={onClose} color='primary' variant='contained'  >Back to video</Button>
                    <Button size='small' onClick={onTakeQuiz} color='secondary' variant='contained' disableElevation>Take quiz</Button>
                </Box>
            </Box>
        </Dialog>
    )
}

export default VideoPlayerCloseConfirmationDialog